import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    GetPatientLocalSearchListQuery,
    PatientForListResponse,
    PatientsServiceProxy
} from '../../../../shared/service-proxies/service-proxies';


@Component({
    templateUrl: 'busquedapacientes-grid.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class BusquedaPacientesGridComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    data: PatientForListResponse[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;
    query: GetPatientLocalSearchListQuery = new GetPatientLocalSearchListQuery();

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private patientService: PatientsServiceProxy

    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    ngOnInit() {
        const self = this;

        self.cols = [
            { field: 'fullName', header: this.l('Busquedas.Pacientes.Nombre'), isActive: true },
            { field: 'nss', header: this.l('Busquedas.Pacientes.NSS'), isActive: true },
            { field: 'sexDesc', header: this.l('Busquedas.Pacientes.Sexo'), isActive: true },
            { field: 'patientTypeImssDesc', header: this.l('Busquedas.Pacientes.TipoPaciente'), isActive: true },
            { field: 'medicalAttache', header: this.l('Busquedas.Pacientes.AgregadoMedico'), isActive: true },
            { field: 'idee', header: this.l('Busquedas.Pacientes.IDEE'), isActive: true }
        ];

        self.query = self.modalConfig.data.query;
        self.getList();
    }


    getList(): void {
        const self = this;

        self.blockedDocument = true;

        self.patientService.getPatientsLocalSearchList(self.query)
            .pipe(finalize(() => {
                self.blockedDocument = false;
            }))
            .subscribe(data => {
                self.data = data.items;

                // Calculate paged table summary
                self.pagedTableSummary = self.getPagedTableSummay(data.totalCount, self.query.pageNumber, self.query.pageSize);
            });
    }

    loadData(event: LazyLoadEvent) {
        const self = this;

        if (event.sortField) {
            self.query.sorting = event.sortField + ' ' + (event.sortOrder === 1 ? 'ASC' : 'DESC');
        } else {
            self.query.sorting = '';
        }

        self.query.pageNumber = 1 + (event.first / event.rows);
        self.query.pageSize = event.rows;

        self.getList();
    }


    return(pacienteId: number): void {
        const self = this;

        self.modalRef.close(pacienteId);
    }
}
